<template>
  <div class="teacherList">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :offset="500"
    >
      <ul class="list">
        <li v-for="item in Content" :key="item.id" @click="$router.push('/teacher-lesson/' + item.id)">
          <div class="img-content">
            <img v-if="item.avatar" :src="item.avatar" alt="" />
            <img v-else src="../../../static/img/default-teacher.png" alt="" />
          </div>
          <div class="teacher-name o1">{{item.nick_name}}</div>
          <div class="school o1">{{item.department}}</div>
        </li>
      </ul>
    </van-list>
  </div>
</template>
<script>
export default {
  name: "teacherList",
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      len: 10,
      Content: []
    };
  },
  methods: {
    onLoad() {
      this.getlist();
      this.page++;
    },
    getlist() {
      this.$api.get(
        "",
        {
          api: "/v1/user/index1",
          page: this.page,
          len: this.len
        },
        res => {
          if (res.status === 1) {
            this.loading = false;
            if (res.data.list.length > 0) {
              this.Content = this.Content.concat(res.data.list);
              this.finished = false;
            } else {
              this.finished = true; // 结束加载状态
            }
          }
        }
      );
    }
  }
};
</script>
<style scoped>
.teacherList {
  background: rgb(242, 242, 242);
  min-height: 100vh;
  padding: 0.4rem;
  box-sizing: border-box;
}
.teacherList *{
  box-sizing: border-box;
}
.teacherList .list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.373rem;
}
.teacherList li {
  width: 4.4rem;
  padding: 0.533rem .213rem 0.4rem;
  background: #ffffff;
  box-shadow: 0px 0.053rem 0.453rem 0px #2119230a;
  text-align: center;
  border-radius: 0.16rem;
}
.teacherList li .img-content {
  width: 2.293rem;
  height: 2.293rem;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
  padding: 0.053rem; /* 必须使用 padding 来模拟边框的宽度 */
  background: linear-gradient(270deg, #e2a8ff 0%, #5fdcfe 100%) border-box,
    white padding-box; /* 第一层是渐变边框，第二层是内部背景色 */
}
.teacherList li .img-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.teacherList li .teacher-name {
  color: #333333;
  font-size: 0.4rem;
  font-weight: 500;
  line-height: 0.56rem;
  margin-top: 0.347rem;
  font-weight: 500;
}
.teacherList li .school {
  color: rgba(17, 29, 58, 0.4);
  font-size: 0.347rem;
  line-height: 0.48rem;
  margin-top: 0.133rem;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher-list/teacher.vue